<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>Sephardic and Mizrahi Jewry</strong></h1>
<p class="subtitle"><em>From the Golden Age of Spain to Modern Times</em></p>
<p class="author"><span class="small">EDITED BY</span><br/><em>Zion Zohar</em></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b5f6e7a6